import { Component } from '@theme/component';

class textFormatter extends Component{
    connectedCallback(){
        this.element = this;
        this.convertTextToList();
    }

    convertTextToList() {
        const container = this.element;
        
        const pElements = container.querySelectorAll('p');
        let allTextContent = '';
        let targetContainer = null;
        let hasSpan = false;
        
        pElements.forEach(p => {
            console.log(p);
            const spans = p.querySelectorAll('span');
            if (spans.length > 0) {
                allTextContent += (spans[0].textContent || spans[0].innerText).trim() + ' ';
                if (!targetContainer) {
                    targetContainer = p;
                    hasSpan = true;
                }
            } else {
                allTextContent += (p.textContent || p.innerText).trim() + ' ';
                if (!targetContainer) {
                    targetContainer = p;
                    hasSpan = false;
                }
            }
        });
        
        allTextContent = allTextContent.trim();
        console.log(allTextContent);
        if (allTextContent.includes(' - ') || allTextContent.startsWith('- ') || allTextContent.startsWith(' -')) {
            const items = allTextContent.split(' - ')
                .map(item => item.replace(/^- /, '').trim())
                .filter(item => item !== '');

            
            if (items.length > 1 && targetContainer) {
                const ul = document.createElement('ul');
                ul.className = 'converted-list';
                
                items.forEach(item => {
                    if (item.trim() !== '') {
                        const li = document.createElement('li');
                        const p = document.createElement('p');
                        p.textContent = item.trim();
                        ul.appendChild(li);
                        li.appendChild(p);
                    }
                });
                
                pElements.forEach((p, index) => {
                    if (index > 0) {
                        p.remove();
                    }
                });
                
                if (hasSpan) {
                    const span = targetContainer.querySelector('span');
                    if (span) {
                        span.innerHTML = '';
                        span.appendChild(ul);
                    }
                } else {
                    targetContainer.innerHTML = '';
                    targetContainer.appendChild(ul);
                }
            }
        }
    }
}

if (!customElements.get('text-formatter')) {
  customElements.define('text-formatter', textFormatter);
}